import React from "react";
import Log from "../Components/Log.jsx";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import useStore from "../store";
import { useChatNavigation } from "./ChatNavigationProvider.jsx";

const LogList = ({ onLogClick }) => {
  const navigate = useNavigate();
  const { leaveChatForHistory, requestNewSituation } = useChatNavigation();
  const logs = useStore((state) => state.logs); // Zustand에서 logs 상태 가져오기
  const isNewChatActive = useStore((state) => state.isNewChatActive); // "새 대화 중" 상태 가져오기
  const tempLog = useStore((state) => state.tempLog); // 임시 로그 상태 가져오기
  const hasActiveChatSession = useStore((state) => state.hasActiveChatSession);
  const isChatMode = useStore((state) => state.isChatMode);
  const chatHistory = useStore((state) => state.chatHistory);
  const updatedQuestion = useStore((state) => state.updatedQuestion);

  // id가 클수록 최신: 내림차순 정렬
  const sortedLogs = [...logs].sort((a, b) => b.id - a.id);
  const hasActiveChat = isChatMode || hasActiveChatSession || isNewChatActive;
  const firstUserMessage = chatHistory.find((message) => message.type === "user")?.content;
  const activeChatLabel = firstUserMessage || updatedQuestion || "진행 중인 대화";

  const handlePendingSearchClick = () => {
    leaveChatForHistory();
    navigate("/main/q/waiting");
    onLogClick?.();
  };

  return (
    <Wrapper>
      {tempLog && (
        <TempLogItem type="button" onClick={handlePendingSearchClick}>
          <TempLogContent>{tempLog}</TempLogContent>
        </TempLogItem>
      )}
      {hasActiveChat && (
        <NewChatItem type="button" onClick={requestNewSituation}>
          <NewChatBadge>대화 중</NewChatBadge>
          <NewChatText>{activeChatLabel}</NewChatText>
        </NewChatItem>
      )}
      
      {sortedLogs.map((log) => {
        return <Log key={log.id} id={log.id} content={log.content} onLogClick={onLogClick}></Log>;
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 650px; /* 질문 입력 필드의 맨밑 line과 이용약관 밑 line이 일직선 되도록 설정*/
  overflow-y: auto;
  margin-right: 7px; // 스크롤바 위치 설정(10px 기준은 스크롤바 중앙에서부터)
  padding-top: 12px; // '새로운 상황'과 첫 번째 대화 로그 사이 간격

  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 6px; // 스크롤바 너비
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
`;

// "새 대화 중" 아이템 스타일
const NewChatItem = styled.button`
  width: 240px;
  height: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  margin-left: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
`;

const NewChatBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  height: 24px;
  background: #ededed;
  border-radius: 24px;
  flex-shrink: 0;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.6);
`;

const NewChatText = styled.div`
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.6);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// 임시 로그 아이템 스타일 (shimmer 효과)
const TempLogItem = styled.button`
  width: 240px;
  max-height: 72px;
  margin-bottom: 24px;
  margin-left: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
`;

const TempLogContent = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.3);
  
  /* Shimmer 효과 */
  background: linear-gradient(
    120deg,
    rgba(180, 180, 180, 0.15) 0%,
    rgba(80, 80, 80, 0.85) 50%,
    rgba(180, 180, 180, 0.15) 100%
  );
  background-size: 200% auto;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: shimmer 2s infinite linear;

  @keyframes shimmer {
    0% {
      background-position: 100% 100%;
    }
    100% {
      background-position: -100% 0;
    }
  }
`;

export default LogList;
